export function isLocalHost() {
  const { port } = new URL(window.location.href);
  return port === '3000';
}

/**
 * Returns the base URL for the web app.
 * - In local development: http://localhost:3000
 * - In production/preview: window.location.origin
 */
export function getBaseUrl() {
  return isLocalHost() ? 'http://localhost:3000' : window.location.origin;
}
